import React, { useState, useEffect } from "react";
import SortIcon from "../../Assets/Images/sort-icon.png";
import { useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import LightBin from "../../Assets/Images/light-bin.svg";

export default function AllClientTable({ data, isLoading, onDelete }) {
  const [sortConfig, setSortConfig] = useState({ key: '', direction: 'ascending' });
  const [sortedData, setSortedData] = useState([data]);
  const [filterConfig, setFilterConfig] = useState({ startDate: '', endDate: '' });
  const [filteredData, setFilteredData] = useState(data); // Data after filtering



  const navigate = useNavigate();

  useEffect(() => {
    const sortedArray = data?.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    setSortedData(sortedArray);
  }, [data]);

  console.log("sortedData", sortedData)

  useEffect(() => {
    const { startDate, endDate } = filterConfig;
    const filtered = data.filter(client => {
      const clientStartDate = new Date(client.startDate);
      const clientEndDate = new Date(client.endDate || client.startDate); // Use startDate as fallback
      const filterStart = startDate ? new Date(startDate) : null;
      const filterEnd = endDate ? new Date(endDate) : null;

      // Check filter conditions
      if (filterStart && clientStartDate < filterStart) return false;
      if (filterEnd && clientEndDate > filterEnd) return false;
      return true;
    });
    setFilteredData(filtered);
  }, [filterConfig, data]);

  const handleSort = (key) => {
    let sortedArray;
    let direction;

    if (sortConfig.direction === "ascending") {
      direction = "descending";
    }
    else {
      direction = "ascending";
    }

    switch (key) {
      case "name":
        let sortedName;
        if (sortConfig.direction === "ascending") {
          sortedName = sortedData.sort((a, b) => a.name.localeCompare(b.name));
        }
        else {
          sortedName = sortedData.sort((a, b) => b.name.localeCompare(a.name));
        }
        sortedArray = sortedName;
        break;
      case "company":
        let company;
        if (sortConfig.direction === "ascending") {
          company = sortedData.sort((a, b) => a.company.localeCompare(b.company));
        }
        else {
          company = sortedData.sort((a, b) => b.company.localeCompare(a.company));
        }
        sortedArray = company;
        break;
      case "totalAssessments":
        let totalAsmts;
        if (sortConfig.direction === "ascending") {
          totalAsmts = sortedData.sort((a, b) => a.totalAssessments - b.totalAssessments);
        }
        else {
          totalAsmts = sortedData.sort((a, b) => b.totalAssessments - a.totalAssessments);
        }
        sortedArray = totalAsmts;
        break;
      case "complete":
        let completeAsmts;
        if (sortConfig.direction === "ascending") {
          completeAsmts = sortedData.sort((a, b) => a.complete - b.complete);
        }
        else {
          completeAsmts = sortedData.sort((a, b) => b.complete - a.complete);
        }
        sortedArray = completeAsmts;
        break;
      case "started":
        sortedArray = sortedData.sort((a, b) => {
          const dateA = new Date(a.created_at);
          const dateB = new Date(b.created_at);

          return sortConfig.direction === "ascending"
            ? dateA - dateB
            : dateB - dateA;
        });
        break;
    }
    setSortedData(sortedArray);
    setSortConfig({ key, direction });
  };

  const handleArrowClick = (id) => {
    const clientData = sortedData.find(client => client.id === id);
    // navigate(`/added-client/${id}`, { state: { client: clientData } });
    navigate(`/client/${id}?tab=1`, { state: { client: clientData } })
  };

  const getProgress = (client) => {
    const total = client?.totalAssessments || 0;
    if (!total) return 0;

    const completed = client?.assessments?.filter(asmt => {
      const assessmentComplete = asmt.status === "complete";
      const membersComplete = asmt.members
        ? asmt.members.every(m => m.status === "complete")
        : true;
      return assessmentComplete && membersComplete;
    }).length || 0;

    return (completed / total) * 100;
  };

  const getCompletedAssessmentsCount = (client) => {
    if (!client?.assessments?.length) return 0;

    return client.assessments.filter(asmt => {
      const assessmentComplete = asmt.status === "complete";
      const membersComplete = asmt.members
        ? asmt.members.every(m => m.status === "complete")
        : true;

      return assessmentComplete && membersComplete;
    }).length;
  };

  console.log("sortedData", sortedData)

  return (
    <div className="client-table-container">
      <table className="client-table">
        <thead>
          <tr className="client-header">
            <th className="client-header-cell" style={{ padding: '0' }}></th>
            <th className="client-header-cell name" onClick={() => handleSort('name')}>
              <img src={SortIcon} alt="sort Icon" className="sort-icon" />Client Name
            </th>
            <th className="client-header-cell company" onClick={() => handleSort('company')}>
              <img src={SortIcon} alt="sort Icon" className="sort-icon" />Company Name
            </th>
            <th className="client-header-cell groupid">
              Group ID
            </th>
            <th className="client-header-cell total-assessments" onClick={() => handleSort('totalAssessments')}>
              <img src={SortIcon} alt="sort Icon" className="sort-icon" />Assessments
            </th>
            <th className="client-header-cell complete" onClick={() => handleSort('complete')}>
              <img src={SortIcon} alt="sort Icon" className="sort-icon" />Completion Status
            </th>
            <th className="client-header-cell started" onClick={() => handleSort('started')}>
              <img src={SortIcon} alt="sort Icon" className="sort-icon" />Date
            </th>
            {onDelete && <th className="client-header-cell action-column"></th>}
          </tr>
        </thead>
        <tbody className="client-body">
          {
            isLoading ?
              <tr>
                <div className='loading'>
                  <CircularProgress style={{ color: '##245775' }} size={40} />
                </div>
              </tr> :
              <>
                {sortedData?.map((client, idx) => (
                  <tr key={client.id} className="client-row" style={{ cursor: "pointer" }} onClick={() => handleArrowClick(client.id)} >
                    <td className="client-cell serial-number"><span style={{ marginRight: "20px" }}>{idx + 1}.</span></td>
                    <td className="client-cell client-name">{`${client?.name}`}</td>
                    <td className="client-cell company-name">{client?.company}</td>
                    <td className="client-cell group-id">{client?.groupid}</td>
                    <td className="client-cell respondents">
                      {client?.respondents}
                    </td>
                    <td className="client-cell members">
                      <div className="client-completion">
                        <span>
                          {getCompletedAssessmentsCount(client)}/{client?.totalAssessments || 0}
                        </span>
                        <div className="client-progress-bar">
                          <div className="client-progress"style={{ width: `${getProgress(client)}%` }} ></div>
                        </div>
                      </div>
                    </td>

                    <td className="client-cell date">
                      <div style={{ marginRight: '10px' }}>
                        {client?.created_at
                          ? (() => {
                            const date = new Date(client.created_at);
                            const month = date.toLocaleString("en-US", { month: "short" });
                            const day = String(date.getDate()).padStart(2, "0");
                            const year = date.getFullYear();
                            return `${month} ${day} ${year}`;
                          })()
                        : ""}
                      </div>
                      <div style={{ marginLeft: '10px', cursor: 'pointer' }} className="arrow"> &gt; </div>
                    </td>
                    {onDelete && (
                      <td className="client-cell client-cell-action" onClick={(e) => e.stopPropagation()}>
                        <button
                          type="button"
                          className="delete-client-btn"
                          onClick={() => onDelete(client.id, client?.name)}
                          aria-label="Delete client"
                          title="Delete client"
                          style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 4, color: '#666', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                        >
                          <img src={LightBin} alt="Light Bin" />
                        </button>
                      </td>
                    )}
                  </tr>
                ))}
                {
                  sortedData?.length === 0 && <tr>
                    <div className='loading'>
                      No Data Found
                    </div>
                  </tr>
                }
              </>

          }
        </tbody>
      </table>
    </div>
  );
}
